export default __webpack_public_path__ + "static/media/refined-search.58736d95.png";